import Immutable from "immutable";

import { Client } from "resourceModels";
import getAPIRoot from "services/api-root";

export default class ZendeskPlatformRecord extends Immutable.Record({
  name: "zendesk_chat",
  fullName: "Zendesk Chat",
  auth: Immutable.Map({
    redirectUri: `${process.env.NODE_ENV === "production"
      ? getAPIRoot()
      : "https://a584bd7d.ngrok.io"
    }/oauth/zendesk`
  }),
  agentEmail: "",
  accessToken: "",
  enabled: true,
  accountKey: "",

  isVisibleToClient(client: Client): boolean {
    return (
      (
        client.hasFullSitePrivileges &&
        client.features.get("zendeskClient")
      ) ||
      (
        client.hasFullSitePrivileges &&
        client.features.get("zendeskLiveChatHandoff")
      )
    );
  }
}) {}
